import { WordingMultiAstrologyMeditationLove } from '@/types';

export const MULTI_ASTROLOGY_MEDITATION_LOVE_WORDING_LT: WordingMultiAstrologyMeditationLove = {
  components_header_media_content: 'Astrologija',
  components_header_media_multi_content_2: 'Meditacija',
  components_header_media_multi_content_3: 'Meilė',
  components_header_text1: 'Gidai',
  components_header_text2: 'Dienoraštis',
  hero_text: 'Raskite aiškumą, pusiausvyrą ir ryšį.',
  hero_button_text: 'Pradėkite savo kelionę',
  components_ressources_subheader_text: 'Patarimai ir įkvėpimas',
  components_ressources_span_text: 'Jame derinamos asmeninės astrologijos įžvalgos, raminančios meditacijos praktikos ir apgalvotas meilės gairės, siekiant paremti savęs pažinimą, emocinę pusiausvyrą ir gilesnį ryšį.',
  components_ressources_card_1_title: 'Meditacijos patarimai',
  components_ressources_card_1_text: 'Trumpas vadovas, kaip geriau nusiraminti, kvėpuoti ir susikaupti.',
  components_ressources_card_2_title: 'Meilės vadovavimas',
  components_ressources_card_2_text: 'Paprasti patarimai, kaip sukurti stipresnį ryšį ir emocinę pusiausvyrą.',
  components_ressources_link: 'Sužinokite daugiau',
  components_notes_and_google_title_1: 'Raskite aiškumą',
  components_notes_and_google_title_2: 'Vidinė ramybė',
  components_notes_and_google_title_3: 'Širdies ryšys',
  media_content_section_multi_1_subheader_text: 'Mūsų podcast\'as',
  media_content_section_multi_2_subheader_text: 'Mūsų meditacijos',
  media_content_section_multi_3_subheader_text: 'Tikras pokalbis apie kosminę romantiką',
  page_media_content_menu_antistress: 'Antistresas',
  page_media_content_menu_mindfulness: 'Sąmoningumas',
  page_media_content_menu_energyboost: 'Energijos pliūpsnis',
  page_media_content_menu_mantra: 'Mantra',
  page_media_content_menu_foundations: 'Pamatai',
  page_media_content_menu_spirituality: 'Dvasingumas',
  page_media_content_menu_tarot: 'Taro kortos',
  page_media_content_menu_psychology: 'Psichologija',
  page_media_content_menu_trends: 'Tendencijos',
  page_media_content_menu_compatibility: 'Suderinamumas',
  page_media_content_menu_love: 'Meilė',
  text2_section_title: 'BLOGAS',
  text2_section_subheader_text: 'Straipsniai ir įžvalgos',
  text2_section_button_more: 'Įkelti daugiau',
  components_text1_section_title: 'VADOVAI',
  components_text1_subheader_text: 'Kosminės žinios kasdieniam susiderinimui',
  components_text1_span_text: 'Susitaikykite su visatos ritmais: tyrinėkite kruopščiai atrinktą išsamių astrologinių ir meditacinių vadovų kolekciją, skirtą pažadinti vidinį aiškumą, pagilinti savimonę ir paremti jūsų sielinio, dangiškojo augimo kelionę.',
  components_text1_card_1_title: 'Atvira tylai',
  components_text1_card_1_text: 'Pradėkite savo kelionę su pamatinės meditacijos ir astrologijos vadovais – tai idealiai tinka ieškantiems, kuriuos traukia vidinė ramybė, kosminiai modeliai ir asmeninė įžvalga.',
  components_text1_card_3_title: 'Proto ir kūno ryšys',
  components_text1_card_3_text: 'Atskleiskite gilesnius savo vidinio pasaulio sluoksnius. Šie vadovai prasiskverbia pro paviršių ir atskleidžia prasmę, emocijas bei sąmoningumo modelius, kurie formuoja jūsų patirtį.',
  components_text1_card_2_title: 'Apmąstykite ir integruokite',
  components_text1_card_2_text: 'Nuo emocinių blokų iki planetinių ciklų – šie vadovai siūlo įrankius apmąstymams, gydymui ir transformacijai per sąmoningus ritualus ir astrologinę išmintį.',
  components_text1_link: 'Peržiūrėti visus vadovus',
  components_footer_text: 'Raskite aiškumą, subalansuokite savo protą ir susiekite su prasme – tai jūsų vieta astrologijai, meditacijai ir meilei.',
};